<template>
  <div>
    <v-row class="justify-center">
      <v-flex lg2 sm10 xs10>
        <v-text-field v-model="idValue" label="아이디 입력" single-line outlined dense hide-details></v-text-field>
      </v-flex>
    </v-row>
    <v-row class="mt-2 mb-5 justify-center">
      <v-flex lg2 sm10 xs10>
        <v-text-field
          v-model="passwordValue"
          :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
          :type="passwordShow ? 'text' : 'password'"
          label="비밀번호를 입력해주세요"
          class="input-group--focused"
          @click:append="passwordShow = !passwordShow"
          single-line
          outlined
          dense
          hide-details
        ></v-text-field>
      </v-flex>
    </v-row>
    <v-row class="justify-center">
      <v-flex lg2 sm10 xs10>
        <v-btn color="primary" class="col-12" height="42" @click="login">로그인</v-btn>
      </v-flex>
    </v-row>

    <v-row class="mt-4 mb-6 justify-center">
      <v-flex lg2 sm4 xs4>
        <div style="justify-content: center;">
          <div style="float:left;">
            <v-checkbox v-model="autoLogin" color="primary" hide-details class="mt-0 pt-0"></v-checkbox>
          </div>
          <div style="float:left;">
            <p class="caption mb-0 text-center" style="line-height: 2.3;">
              자동로그인
            </p>
          </div>

          <div style="float:right;">
            <p class="caption mb-0 text-center idSearch" style="cursor: pointer; float:left;line-height: 2.3;" @click="findId">
              아이디 찾기
            </p>
            <p class="caption mb-0 text-center ml-3 mr-3" style="float:left;line-height: 2.3;">
              |
            </p>
            <p class="caption mb-0 text-center passSearch" style="cursor: pointer; float:left; line-height: 2.3;" @click="findPassword">
              비밀번호 찾기
            </p>
          </div>
        </div>
      </v-flex>
    </v-row>

    <v-row class="justify-center mt-6 mb-6">
      <v-flex lg2 sm4 xs4>
        <p class="body-2 mb-1 text-center">계정이 없으신가요?</p>
        <p class="body-2 mb-0 text-center font-weight-black signup" style="cursor: pointer;" @click="signUpMembership">
          회원가입/신청하기
        </p>
      </v-flex>
    </v-row>
    <Alert ref="Alert"></Alert>
  </div>
</template>
<style>
.passSearch:hover,
.idSearch:hover,
.signup:hover {
  color: #b3d4fc;
  text-decoration: underline;
}
</style>
<script>
import M from "@/libs/mapping.js";
import store from "../../../store";
import Alert from "@/components/common/Alert.vue";
import CommonMixin from "@/mixins/CommonMixin.js";
import jwt from "jsonwebtoken";

export default {
  data() {
    return {
      M,
      passwordShow: false,
      password: "Password",
      passwordValue: "",
      idValue: "",
      autoLogin: false,
      signKey: "shoplus-happy-day",
    };
  },
  mixins: [CommonMixin],
  methods: {
    login: async function() {
      if (!this.idValue) {
        this.alertShow("아이디를 입력해주세요.");
        return false;
      }
      if (!this.passwordValue) {
        this.alertShow("비밀번호를 입력해주세요.");
        return false;
      }

      try {
        this.setMallId(this.idValue);
        let result = await M.api(M.entry("/users/login"), {
          mall_id: this.idValue,
          password: this.passwordValue,
        });
        /**
         * 물고 다닐 세션, 리프레시 토큰
         */
        sessionStorage.shoplusAuthServiceId = result.mall_id;
        sessionStorage.shoplusAuthServiceMode = "any";
        sessionStorage.shoplusAuthServiceAccessToken = result.access_token;
        localStorage.shoplusAuthServiceRefreshToken = result.refresh_token;

        /**
         * 자동로그인 체크시
         */
        if (this.autoLogin == true) {
          localStorage.shoplusAuthServiceId = this.idValue;
          localStorage.shoplusAuthServicePw = this.passwordValue;
        }

        let tokenDecoded = jwt.verify(result.access_token, this.signKey);
        if (tokenDecoded.mall_id && tokenDecoded.scope === "cert_product") {
          this.moveAdminPage(this.idValue);
        } else {
          this.setMallId(null);
          this.alertShow("서비스 신청 상태 입니다.");
        }
      } catch (e) {
        this.setMallId(null);
      }
    },
    findId: function() {
      location.href = "/shoplus_service/findId";
    },
    findPassword: function() {
      location.href = "/shoplus_service/findPassword";
    },
    signUpMembership: function() {
      location.href = "/shoplus_service/signUpMembership";
    },
    moveAdminPage: function() {
      location.href = `/shoplus_service/${this.idValue}/authservice`;
    },
    //mall id 설정
    setMallId: function(v) {
      store.commit("SET_MALL_ID", v);
    },
  },
  components: {
    Alert,
  },
  created: function() {
    this.idValue = "";
    this.passwordValue = "";
    if (localStorage.shoplusAuthServiceId && localStorage.shoplusAuthServicePw) {
      this.idValue = localStorage.shoplusAuthServiceId;
      this.passwordValue = localStorage.shoplusAuthServicePw;
      this.autoLogin = true;
    }
  },
};
</script>
